<template>
  <div>
    <b-row
      align-h="between"
    >
      <b-col
        v-show="simulationData.companyName"
        class="simulation-report-header__enterprise"
        mb="4"
      >
        <div>
          <div>{{$t('engineering.load-simulation.companyName')}}</div>
          <div class="font-weight-bold">{{ simulationData.companyName }}</div>
        </div>
      </b-col>
      <b-col
        v-show="simulationData.regionalName"
        class="simulation-report-header__align-items--center"
        mb="4"
      >
        <div>
          <div>{{$t('engineering.load-simulation.regionalName')}}</div>
          <div class="font-weight-bold">{{ simulationData.regionalName }}</div>
        </div>
      </b-col>
      <b-col
        class="simulation-report-header__installation"
        mb="4"
        :class="installationAlignEnd"
      >
        <div>
          <div>{{$t('engineering.load-simulation.installationName')}}</div>
          <div class="font-weight-bold">{{ simulationData.installationName }}</div>
        </div>
      </b-col>
    </b-row>
    <div class="mt-4 simulation-report-header__title">
      {{$t('engineering.load-simulation.simulation-data')}}
    </div>
    <div class="mt-1 simulation-report-header__border p-2">
      <b-row
        class="justify-content-around"
      >
        <b-col
          class="mb-2 mb-sm-2 mb-md-0"
          sm="12"
          md="4"
        >
          <div>
            <label>{{$t('engineering.load-simulation.assetName')}}:</label>
            <label>{{ simulationData.assetName }}</label>
          </div>
          <div>
            <label>
              {{$t('engineering.load-simulation.repetitionNumber')}}:
            </label>
            <span>{{ simulationData.repetitionsNumber }}</span>
          </div>
        </b-col>
        <b-col
          class="simulation-report-header__align-items--center mb-2 mb-sm-2 mb-md-0"
          sm="12"
          md="4"
        >
          <div>
            <div>
              <label>
                {{$t('engineering.load-simulation.coolingCommand')}}:
              </label>
              <span>
                {{ coolingCommandLabel }}
              </span>
            </div>
            <div>
              <label>
                {{$t('engineering.load-simulation.timeIntervalBetweenDataMinutes')}}:
              </label>
              <span>{{ simulationData.timeIntervalBetweenDataMinutes }}</span>
            </div>
          </div>
        </b-col>
        <b-col
          class="simulation-report-header__align-items--end"
          sm="12"
          md="4"
        >
          <div>
            <div>
              <label>
                {{$t('engineering.load-simulation.oilInitialTemperature')}}:
              </label>
              <span>{{ simulationData.oilInitialTemperature }}</span>
            </div>
            <div>
              <label>
                {{$t('engineering.load-simulation.windingInitialTemperature')}}:
              </label>
              <span>{{ simulationData.windingInitialTemperature }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LoadSimulationHeader',
  props: {
    simulationData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    coolingCommandLabel() {
      if (this.simulationData.coolingCommand) {
        return this.$t(`enums.engineering.load-simulation.cooling-commands.
        ${ this.simulationData.coolingCommand }`);
      }

      return '';
    },
    installationAlignEnd() {
      return {
        'simulation-report-header__align-items--end': !!this.simulationData.regionalName,
      };
    },
  },
};
</script>
<style lang="sass" scoped>
@import "src/styles/defaults/mobile-first"

.simulation-report
  &-header
    &__title
      font-size: 1.2rem
    &__enterprise
      color: var(--color-secondary)
    &__align-items--center
      display: flex
      flex-direction: column
      align-items: center
    &__align-items--end
      display: flex
      flex-direction: column
      align-items: flex-end
    &__installation
      color: var(--color-success)
    &__border
      border: 2px solid #bdbdbd52
      border-radius: 5px

    +media-max-sm()
      &__align-items--center, &__align-items--end
        display: block
</style>
